"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9897],{

/***/ 7127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ edit_profile_ChangeEmail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/QueryProvider/index.tsx
var QueryProvider = __webpack_require__(62780);
// EXTERNAL MODULE: ./src/features/edit-profile/styled.ts
var styled = __webpack_require__(686);
// EXTERNAL MODULE: ./src/features/edit-profile/components/SuccessCard.tsx
var SuccessCard = __webpack_require__(44278);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/lib/api/setting.ts
var setting = __webpack_require__(45621);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangeEmail/store.ts






var changeEmailStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        changeToken: null,
        isLoading: false,
        email: null,
        getEmailToken: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(password) {
                var data, res, _data, response, error, error_type, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.prev = 1;
                            data = {
                                type: "CHANGE_TOKEN_TYPE_EMAIL",
                                req_type: "CHANGE_TOKEN_REQ_TYPE_EDIT",
                                password: password
                            };
                            _ctx.next = 5;
                            return setting/* default.getChangePasswordToken */.ZP.getChangePasswordToken(data);
                        case 5:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 8;
                                break;
                            }
                            throw new Error("Attempt to get change token failed");
                        case 8:
                            _data = res.data, response = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                            if (!(error_type || error)) {
                                _ctx.next = 11;
                                break;
                            }
                            throw new Error(message);
                        case 11:
                            set({
                                changeToken: response.change_token,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](1);
                            set({
                                isLoading: false
                            });
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        15
                    ]
                ]);
            }));
            return function(password) {
                return _ref.apply(this, arguments);
            };
        }(),
        updateEmail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                var res, _data, data, error, error_type, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return setting/* default.updateEmail */.ZP.updateEmail(params);
                        case 4:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Attempt to update email failed");
                        case 7:
                            _data = res.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                            if (!(error_type || error)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(message);
                        case 10:
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            set({
                                isLoading: false,
                                email: params.email
                            });
                            return _ctx.abrupt("return", {
                                data: "Success",
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](1);
                            set({
                                isLoading: false
                            });
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        15
                    ]
                ]);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        confirmOTP: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                var res, _data, data, error, error_type, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return setting/* default.confirmEmailOTP */.ZP.confirmEmailOTP(params);
                        case 4:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Attempt to confirm email OTP failed");
                        case 7:
                            _data = res.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                            if (!(error_type || error)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(message);
                        case 10:
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", {
                                data: data || "Success",
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](1);
                            set({
                                isLoading: false
                            });
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        15
                    ]
                ]);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        resendOTP: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, email, changeToken, updateEmail, params;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = get(), email = ref.email, changeToken = ref.changeToken, updateEmail = ref.updateEmail;
                        params = {
                            change_token: changeToken,
                            email: email
                        };
                        _ctx.next = 4;
                        return updateEmail(params);
                    case 4:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    };
});
/* harmony default export */ var store = (changeEmailStore);

// EXTERNAL MODULE: ./src/features/edit-profile/components/VerifyPassword.tsx
var VerifyPassword = __webpack_require__(22105);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangeEmail/VerifyPassword.tsx






function VerifyPassword_VerifyPassword(param) {
    var onNext = param.onNext, cancelLink = param.cancelLink, _onClickCancel = param.onClickCancel, onClickCancel = _onClickCancel === void 0 ? function() {} : _onClickCancel;
    var ref = (0,_sliced_to_array/* default */.Z)(store(function(s) {
        return [
            s.isLoading,
            s.getEmailToken, 
        ];
    }), 2), isLoading = ref[0], getEmailToken = ref[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(password) {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getEmailToken(password);
                    case 2:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            onNext();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(password) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyPassword/* default */.Z, {
        isLoading: isLoading,
        onSubmit: handleSubmit,
        cancelLink: cancelLink,
        onClickCancel: onClickCancel
    });
}
/* harmony default export */ var ChangeEmail_VerifyPassword = (VerifyPassword_VerifyPassword);

// EXTERNAL MODULE: ./src/features/reset-password/styled.ts
var reset_password_styled = __webpack_require__(10504);
// EXTERNAL MODULE: ./src/hooks/useForm.js
var useForm = __webpack_require__(15077);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/features/edit-profile/constants.ts + 1 modules
var constants = __webpack_require__(8112);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangeEmail/NewEmail.tsx













var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text, Input = ui/* Common.Input */.Gn.Input;
function NewEmail(param) {
    var email = param.email, onNext = param.onNext, cancelLink = param.cancelLink, _onClickCancel = param.onClickCancel, onClickCancel = _onClickCancel === void 0 ? function() {} : _onClickCancel;
    var ref = (0,_sliced_to_array/* default */.Z)(store(function(s) {
        return [
            s.isLoading,
            s.changeToken,
            s.updateEmail, 
        ];
    }), 3), isLoading = ref[0], changeToken = ref[1], updateEmail = ref[2];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({}), 2), newEmail = ref1[0], setNewEmail = ref1[1];
    var ref2 = (0,react.useState)(""), newEmailError = ref2[0], setNewEmailError = ref2[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var data, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        if (!newEmailError) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 3:
                        data = {
                            change_token: changeToken,
                            email: newEmail
                        };
                        _ctx.next = 6;
                        return updateEmail(data);
                    case 6:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            onNext();
                            setNewEmail({
                                target: {
                                    value: ""
                                }
                            });
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBlurEmail = function() {
        if (!newEmail.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/)) {
            setNewEmailError(constants/* WORDING_FORMAT_EMAIL_WRONG */.Mz);
        } else {
            setNewEmailError("");
        }
        setNewEmail({
            target: {
                value: newEmail.trim()
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                padding: "0 15px 20px 15px",
                width: "100%",
                direction: "column",
                margin: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        size: "16px",
                        family: "bold",
                        mb: "15px",
                        height: "1.5",
                        children: "Masukkan Alamat Email Baru Kamu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        align: "center",
                        width: "100%",
                        mb: "10px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                width: "30%",
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    children: "Email Sekarang"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                family: "bold",
                                "data-cy": "new-email-current-email",
                                children: email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        align: "center",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                width: "30%",
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    children: "Email Baru"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                width: "70%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    type: "email",
                                    name: "new-email",
                                    value: newEmail,
                                    onChange: setNewEmail,
                                    onBlur: handleBlurEmail,
                                    width: "100%",
                                    "data-cy": "new-email-set-new-email-input-box"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !!newEmailError,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                            align: "center",
                            width: "100%",
                            justify: "flex-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                width: "70%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(reset_password_styled/* ErrorText */.y, {
                                    mt: "8px",
                                    "data-cy": "new-email-invalid-email-format",
                                    children: newEmailError
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                mt: "10px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: cancelLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* PasswordCancelButton */.m$, {
                            disabled: false,
                            onClick: onClickCancel,
                            "data-cy": "new-email-cancel-button",
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* PasswordSubmitButton */.G_, {
                        htmlType: "submit",
                        type: "primary",
                        loading: isLoading,
                        onClick: handleSubmit,
                        "data-cy": "new-email-submit-button",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var ChangeEmail_NewEmail = (NewEmail);

// EXTERNAL MODULE: ./src/features/edit-profile/components/ConfirmOTP.tsx + 1 modules
var ConfirmOTP = __webpack_require__(61960);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangeEmail/ConfirmOTP.tsx






function ConfirmOTP_ConfirmOTP(param) {
    var onNext = param.onNext;
    var ref = (0,_sliced_to_array/* default */.Z)(store(function(s) {
        return [
            s.isLoading,
            s.changeToken,
            s.confirmOTP,
            s.resendOTP
        ];
    }), 4), isLoading = ref[0], changeToken = ref[1], confirmOTP = ref[2], resendOTP = ref[3];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(otp) {
            var params, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = {
                            otp: otp,
                            change_token: changeToken
                        };
                        _ctx.next = 3;
                        return confirmOTP(params);
                    case 3:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            onNext();
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(otp) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmOTP/* default */.Z, {
        isLoading: isLoading,
        onSubmit: handleSubmit,
        onResend: resendOTP,
        type: "email"
    });
}
/* harmony default export */ var ChangeEmail_ConfirmOTP = (ConfirmOTP_ConfirmOTP);

// EXTERNAL MODULE: ./src/features/edit-profile/ProgressGuard/index.tsx + 1 modules
var ProgressGuard = __webpack_require__(61040);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangeEmail/index.tsx
/* eslint-disable no-undef */ 











var ChangeEmail_Flex = ui/* Common.Flex */.Gn.Flex, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function ChangeEmail(param) {
    var profile = param.profile, _backLink = param.backLink, backLink = _backLink === void 0 ? "/profile/edit" : _backLink, _backToEditForm = param.backToEditForm, backToEditForm = _backToEditForm === void 0 ? function() {} : _backToEditForm;
    var ref = (0,react.useState)("verify"), step = ref[0], setStep = ref[1];
    var handleBack = function() {
        if (step === "verify") {
            backToEditForm();
            return;
        }
        if (step === "otp") {
            setStep("change");
        }
    };
    var renderTitle = function() {
        var BACK_STEPS = [
            "verify",
            "otp"
        ];
        var showBack = BACK_STEPS.includes(step);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangeEmail_Flex, {
            align: "center",
            style: {
                gap: 8
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: showBack,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                        className: "icon-arrow-left",
                        onClick: handleBack,
                        size: "12px",
                        style: {
                            cursor: "pointer"
                        },
                        "data-cy": "change-index-back-button"
                    })
                }),
                "Ubah Email"
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* EditProfileCard */.pr, {
        variant: "profile-config",
        title: renderTitle(),
        isHideTitle: step === "success",
        "data-cy": "change-index-form",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "securities-box-changePin",
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: step === "verify",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeEmail_VerifyPassword, {
                        onNext: function() {
                            return setStep("change");
                        },
                        cancelLink: "javascript:void(0)",
                        onClickCancel: backToEditForm
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: step === "change",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeEmail_NewEmail, {
                        email: profile.email,
                        onNext: function() {
                            return setStep("otp");
                        },
                        cancelLink: "javascript:void(0)",
                        onClickCancel: backToEditForm
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: step === "otp",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeEmail_ConfirmOTP, {
                        onNext: function() {
                            return setStep("success");
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: step === "success",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessCard/* default */.Z, {
                        type: "email",
                        backLink: backLink
                    })
                })
            ]
        })
    });
}
function ChangeEmailWithProgressGuard(props) {
    var _enableGuard = props.enableGuard, enableGuard = _enableGuard === void 0 ? false : _enableGuard;
    if (!enableGuard) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeEmail, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressGuard/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeEmail, (0,_object_spread/* default */.Z)({}, props))
        })
    });
}
/* harmony default export */ var edit_profile_ChangeEmail = (ChangeEmailWithProgressGuard);


/***/ }),

/***/ 41283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var uniqid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76104);
/* harmony import */ var uniqid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(uniqid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var global_CustomInput_password__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30503);
/* eslint-disable no-undef */ 



function PasswordField(param) {
    var onChange = param.onChange, isError = param.isError, value = param.value;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), val = ref[0], setVal = ref[1];
    var fieldId = uniqid__WEBPACK_IMPORTED_MODULE_2___default()("pw-");
    var handleChange = function(e) {
        var value = e.target.value;
        setVal(value);
        onChange(value);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setVal(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_CustomInput_password__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        name: fieldId,
        id: fieldId,
        error: isError,
        // type={"password"}
        value: val,
        onChange: handleChange,
        required: true,
        width: "100%",
        autoComplete: "new-password",
        "data-cy": "verify-password-input-box"
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PasswordField);


/***/ }),

/***/ 44355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ edit_profile_ChangePhone; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/QueryProvider/index.tsx
var QueryProvider = __webpack_require__(62780);
// EXTERNAL MODULE: ./src/features/register/types.ts
var types = __webpack_require__(72228);
// EXTERNAL MODULE: ./src/features/edit-profile/styled.ts
var styled = __webpack_require__(686);
// EXTERNAL MODULE: ./src/features/edit-profile/components/SuccessCard.tsx
var SuccessCard = __webpack_require__(44278);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/config/APIErrorMessage/index.js + 1 modules
var APIErrorMessage = __webpack_require__(60714);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/lib/api/setting.ts
var setting = __webpack_require__(45621);
// EXTERNAL MODULE: ./src/utils/formatErrorMessage.ts
var formatErrorMessage = __webpack_require__(72360);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangePhone/store.ts










var changePhoneStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        changeToken: null,
        isLoading: false,
        phone: null,
        channel: null,
        setPhone: function(phone, code) {
            set({
                phone: {
                    phone: phone,
                    code: code
                }
            });
        },
        getChangeToken: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(password) {
                var data, res, _data, response, error, error_type, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.prev = 1;
                            data = {
                                type: "CHANGE_TOKEN_TYPE_PHONE",
                                req_type: "CHANGE_TOKEN_REQ_TYPE_EDIT",
                                password: password
                            };
                            _ctx.next = 5;
                            return setting/* default.getChangePasswordToken */.ZP.getChangePasswordToken(data);
                        case 5:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 8;
                                break;
                            }
                            throw new Error("Attempt to get change token failed");
                        case 8:
                            _data = res.data, response = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                            if (!(error_type || error)) {
                                _ctx.next = 11;
                                break;
                            }
                            throw new Error(message);
                        case 11:
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            set({
                                changeToken: response.change_token,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](1);
                            set({
                                isLoading: false
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        16
                    ]
                ]);
            }));
            return function(password) {
                return _ref.apply(this, arguments);
            };
        }(),
        updatePhone: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                var changeToken, paramsData, res, _data, data, error, error_type, message, ref, ref1, status, data1, ref2, errorType, message1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.prev = 1;
                            changeToken = get().changeToken;
                            paramsData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                change_token: changeToken
                            });
                            _ctx.next = 6;
                            return setting/* default.updatePhone */.ZP.updatePhone(paramsData);
                        case 6:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error("Attempt to update phone failed");
                        case 9:
                            _data = res.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                            if (!(error_type || error)) {
                                _ctx.next = 12;
                                break;
                            }
                            throw new Error(message);
                        case 12:
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            set({
                                phone: {
                                    phone: params.phone,
                                    code: params.code
                                },
                                channel: params.channel,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            set({
                                isLoading: false
                            });
                            ref1 = ((ref = _ctx.t0) === null || ref === void 0 ? void 0 : ref.response) || {}, status = ref1.status, data1 = ref1.data;
                            ref2 = data1 || {}, errorType = ref2.error_type, message1 = ref2.message;
                            if (errorType !== "OTP_LIMIT") {
                                APIErrorMessage/* default.APIExodusErrorHandler */.Z.APIExodusErrorHandler(status, errorType, (0,formatErrorMessage/* formatRemoveErrorTypeMobile */.D)(message1));
                            }
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        17
                    ]
                ]);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        confirmOTP: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(otp) {
                var changeToken, params, res, _data, data, error, error_type, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: false
                            });
                            _ctx.prev = 1;
                            changeToken = get().changeToken;
                            params = {
                                change_token: changeToken,
                                otp: otp
                            };
                            _ctx.next = 6;
                            return setting/* default.confirmPhoneOTP */.ZP.confirmPhoneOTP(params);
                        case 6:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error("Attempt to confirm otp failed");
                        case 9:
                            _data = res.data, data = _data.data, error = _data.error, error_type = _data.error_type, message = _data.message;
                            if (!(error_type || error)) {
                                _ctx.next = 12;
                                break;
                            }
                            throw new Error(message);
                        case 12:
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](1);
                            set({
                                isLoading: false
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        17
                    ]
                ]);
            }));
            return function(otp) {
                return _ref.apply(this, arguments);
            };
        }(),
        resendOTP: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, phone, channel, updatePhone;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = get(), phone = ref.phone, channel = ref.channel, updatePhone = ref.updatePhone;
                        return _ctx.abrupt("return", updatePhone((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, phone), {
                            channel: channel
                        })));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    };
});
/* harmony default export */ var store = (changePhoneStore);

// EXTERNAL MODULE: ./src/features/edit-profile/components/VerifyPassword.tsx
var VerifyPassword = __webpack_require__(22105);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangePhone/Verify.tsx






function Verify(param) {
    var onNext = param.onNext, cancelLink = param.cancelLink, _onClickCancel = param.onClickCancel, onClickCancel = _onClickCancel === void 0 ? function() {} : _onClickCancel;
    var ref = (0,_sliced_to_array/* default */.Z)(store(function(s) {
        return [
            s.isLoading,
            s.getChangeToken, 
        ];
    }), 2), isLoading = ref[0], getPhoneToken = ref[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(password) {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getPhoneToken(password);
                    case 2:
                        res = _ctx.sent;
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            onNext();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(password) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyPassword/* default */.Z, {
        isLoading: isLoading,
        onSubmit: handleSubmit,
        cancelLink: cancelLink,
        onClickCancel: onClickCancel
    });
}
/* harmony default export */ var ChangePhone_Verify = (Verify);

// EXTERNAL MODULE: ./src/features/edit-profile/components/ConfirmOTP.tsx + 1 modules
var ConfirmOTP = __webpack_require__(61960);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangePhone/OTP.tsx






function PhoneOTP(param) {
    var onNext = param.onNext, onResend = param.onResend;
    var ref = (0,_sliced_to_array/* default */.Z)(store(function(s) {
        return [
            s.isLoading,
            s.phone,
            s.confirmOTP, 
        ];
    }), 3), isLoading = ref[0], phone = ref[1], confirmOTP = ref[2];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(otp) {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return confirmOTP(otp);
                    case 2:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.data) !== undefined) {
                            onNext();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(otp) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmOTP/* default */.Z, {
        isLoading: isLoading,
        onSubmit: handleSubmit,
        onResend: onResend,
        type: "phone",
        phoneNumber: "".concat(phone === null || phone === void 0 ? void 0 : phone.code).concat(phone === null || phone === void 0 ? void 0 : phone.phone)
    });
}
/* harmony default export */ var OTP = (PhoneOTP);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangePhone/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input[type='tel'] {\n    font-family: var(--regular-font);\n    font-weight: 500;\n    font-size: 16px;\n    border: solid 1px #dadada;\n    border-radius: 2px;\n  }\n\n  .flag-dropdown {\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  padding: 12.5px;\n  width: 100%;\n  border-radius: 4px;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 19px;\n\n  &:disabled {\n    color: #ffffff;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PhoneInput = ui/* Common.TelephoneInput */.Gn.TelephoneInput;
var TelephoneInput = (0,styled_components_browser_esm["default"])(PhoneInput).withConfig({
    componentId: "sc-8b0f6111-0"
})(_templateObject());
var OtpMethodSubmit = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-8b0f6111-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/features/edit-profile/ChangePhone/NewPhone.tsx










var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
function NewPhone(param) {
    var phone = param.phone, onNext = param.onNext, cancelLink = param.cancelLink, _onClickCancel = param.onClickCancel, onClickCancel = _onClickCancel === void 0 ? function() {} : _onClickCancel;
    // eslint-disable-next-line no-unused-vars
    var ref = (0,_sliced_to_array/* default */.Z)(store(function(s) {
        return [
            s.isLoading,
            s.setPhone, 
        ];
    }), 2), isLoading = ref[0], setPhone = ref[1];
    var ref1 = (0,react.useState)(""), phoneNumber = ref1[0], setPhoneNumber = ref1[1];
    var ref2 = (0,react.useState)(null), country = ref2[0], setCountry = ref2[1];
    var handleChange = function(telNumber, selectedCountry) {
        setCountry(selectedCountry);
        setPhoneNumber("".concat(telNumber));
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        e === null || e === void 0 ? void 0 : e.preventDefault();
                        ;
                        setPhone(phoneNumber.slice(country === null || country === void 0 ? void 0 : (ref = country.dialCode) === null || ref === void 0 ? void 0 : ref.length), (ref1 = country === null || country === void 0 ? void 0 : country.dialCode) !== null && ref1 !== void 0 ? ref1 : "");
                        onNext();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                padding: "0 15px 20px 15px",
                width: "100%",
                direction: "column",
                margin: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        size: "16px",
                        family: "bold",
                        mb: "15px",
                        height: "1.5",
                        "data-cy": "change-phone-new-phone-label",
                        children: "Masukkan Nomor Hp Baru Kamu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        align: "center",
                        width: "100%",
                        mb: "10px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                width: "30%",
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    "data-cy": "change-phone-new-phone-current-number-label",
                                    children: "No Hp Sekarang"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                family: "bold",
                                "data-cy": "change-phone-new-phone-current-number-value",
                                children: phone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        align: "center",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                width: "30%",
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    children: "No Hp Baru"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                width: "70%",
                                "data-cy": "change-phone-new-phone-new-number-input-box",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TelephoneInput, {
                                    autoFormat: false,
                                    country: "id",
                                    onChange: handleChange,
                                    value: phoneNumber
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                mt: "10px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: cancelLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* PasswordCancelButton */.m$, {
                            disabled: false,
                            onClick: onClickCancel,
                            "data-cy": "change-phone-new-phone-label-cancel-btton",
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* PasswordSubmitButton */.G_, {
                        htmlType: "submit",
                        type: phoneNumber.length >= 9 ? "primary" : "muted",
                        loading: isLoading,
                        onClick: handleSubmit,
                        "data-cy": "change-phone-new-phone-submit-button",
                        disabled: phoneNumber.length < 9,
                        children: "Submit"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var ChangePhone_NewPhone = (NewPhone);

// EXTERNAL MODULE: ./src/features/edit-profile/ProgressGuard/index.tsx + 1 modules
var ProgressGuard = __webpack_require__(61040);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/global/Icons/ChatSvg.tsx
var ChatSvg = __webpack_require__(37662);
// EXTERNAL MODULE: ./src/global/Icons/WhatsAppSvg.tsx
var WhatsAppSvg = __webpack_require__(68749);
// EXTERNAL MODULE: ./src/global/OtpMethodList/index.tsx + 2 modules
var OtpMethodList = __webpack_require__(50226);
// EXTERNAL MODULE: ./src/typings/auth.ts
var auth = __webpack_require__(97718);
// EXTERNAL MODULE: ./src/utils/textFormatter.ts
var textFormatter = __webpack_require__(23485);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangePhone/SelectOtpMethod.tsx

















var SelectOtpMethod_Text = ui/* Common.Text */.Gn.Text;
var SelectOtpMethod = function(param) {
    var _title = param.title, title = _title === void 0 ? "Pilih Metode Pengiriman Kode Verifikasi" : _title, _description = param.description, description = _description === void 0 ? [
        "Pastikan nomor",
        "benar sebelum mengirimkan OTP"
    ] : _description, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Kirim" : _buttonText, _onNext = param.onNext, onNext = _onNext === void 0 ? function() {} : _onNext, _onError = param.onError, onError = _onError === void 0 ? function() {} : _onError;
    var ref = (0,react.useState)(auth/* OtpChannel.WhatsApp */.z.WhatsApp), selectedMethod = ref[0], setSelectedMethod = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(store(function(s) {
        return [
            s.phone,
            s.isLoading,
            s.updatePhone, 
        ];
    }), 3), phoneData = ref1[0], isLoading = ref1[1], updatePhone = ref1[2];
    var handleOtpSelect = function(value) {
        setSelectedMethod(value);
    };
    var handleFormFinish = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res, ref, ref1, ref2, errorType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return updatePhone((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, phoneData), {
                            channel: selectedMethod
                        }));
                    case 3:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.data) !== undefined) {
                            onNext();
                        }
                        _ctx.next = 12;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        ref2 = ((ref = _ctx.t0) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.data) || {}, errorType = ref2.error_type;
                        if (errorType) onError(errorType);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleFormFinish() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default */.Z, {
        onFinish: handleFormFinish,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
            gutter: [
                0,
                16
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectOtpMethod_Text, {
                        size: "16px",
                        height: "22px",
                        color: "#333333",
                        weight: "bold",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectOtpMethod_Text, {
                        size: "14px",
                        height: "19px",
                        color: "#858585",
                        children: [
                            description[0],
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                children: [
                                    "+",
                                    (0,textFormatter/* formatPhoneNumber */.u)("".concat(phoneData === null || phoneData === void 0 ? void 0 : phoneData.code).concat(phoneData === null || phoneData === void 0 ? void 0 : phoneData.phone))
                                ]
                            }),
                            " ",
                            description[1]
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpMethodList/* default */.Z, {
                        defaultMethod: selectedMethod,
                        data: [
                            {
                                value: auth/* OtpChannel.WhatsApp */.z.WhatsApp,
                                title: "Kirim melalui WhatsApp",
                                description: "Bebas biaya",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    component: WhatsAppSvg/* default */.Z,
                                    style: {
                                        color: "#00AB6B"
                                    }
                                })
                            },
                            {
                                value: auth/* OtpChannel.Sms */.z.Sms,
                                title: "Kirim melalui SMS",
                                description: "Berlaku tarif pengiriman SMS",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    component: ChatSvg/* default */.Z,
                                    style: {
                                        color: "#00AB6B"
                                    }
                                })
                            }, 
                        ],
                        onSelect: handleOtpSelect
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpMethodSubmit, {
                        type: "primary",
                        disabled: !selectedMethod,
                        htmlType: "submit",
                        loading: isLoading,
                        "data-cy": "pin-form-otp-method-submit",
                        children: buttonText
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ChangePhone_SelectOtpMethod = (SelectOtpMethod);

// EXTERNAL MODULE: ./src/features/edit-profile/ModalOtpLimit/index.tsx + 1 modules
var ModalOtpLimit = __webpack_require__(28145);
;// CONCATENATED MODULE: ./src/features/edit-profile/ChangePhone/index.tsx
/* eslint-disable no-script-url */ /* eslint-disable no-undef */ 















var ChangePhone_Flex = ui/* Common.Flex */.Gn.Flex, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var ChangePhoneStep;
(function(ChangePhoneStep) {
    ChangePhoneStep["Verify"] = "verify";
    ChangePhoneStep["Change"] = "change";
    ChangePhoneStep["Otp"] = "otp";
    ChangePhoneStep["SelectOtp"] = "select_otp";
    ChangePhoneStep["Success"] = "success";
})(ChangePhoneStep || (ChangePhoneStep = {}));
function ChangePhone(param) {
    var profile = param.profile, _backLink = param.backLink, backLink = _backLink === void 0 ? "/profile/edit" : _backLink, _backToEditForm = param.backToEditForm, backToEditForm = _backToEditForm === void 0 ? function() {} : _backToEditForm;
    var ref = (0,react.useState)(ChangePhoneStep.Verify), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(false), isOtpLimitVisible = ref1[0], setIsOtpLimitVisible = ref1[1];
    var getIsStepVisible = function(stepValue) {
        return step === stepValue;
    };
    var handleBack = function() {
        var _obj;
        var backStep = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ChangePhoneStep.Verify, function() {
            return backToEditForm();
        }), (0,_define_property/* default */.Z)(_obj, ChangePhoneStep.Otp, ChangePhoneStep.Change), (0,_define_property/* default */.Z)(_obj, ChangePhoneStep.SelectOtp, ChangePhoneStep.Change), _obj);
        if (typeof backStep[step] === "function") {
            backStep[step]();
            return;
        }
        setStep(backStep[step]);
    };
    var handleOtpLimitBack = function() {
        setStep(ChangePhoneStep.Otp);
        setIsOtpLimitVisible(false);
    };
    var handleVerifyPhoneError = function(type) {
        if (type === types/* VerifyPhoneErrorType.OtpLimit */.x.OtpLimit) {
            setIsOtpLimitVisible(true);
        }
    };
    var renderTitle = function() {
        var BACK_STEPS = [
            ChangePhoneStep.SelectOtp,
            ChangePhoneStep.Verify,
            ChangePhoneStep.Otp, 
        ];
        var showBack = BACK_STEPS.includes(step);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangePhone_Flex, {
            align: "center",
            style: {
                gap: 8
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: showBack,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                        className: "icon-arrow-left",
                        onClick: handleBack,
                        size: "12px",
                        style: {
                            cursor: "pointer"
                        },
                        "data-cy": "change-index-back-button"
                    })
                }),
                "Ubah Nomor Hp"
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOtpLimit/* default */.Z, {
                onBackClick: handleOtpLimitBack,
                visible: isOtpLimitVisible
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* EditProfileCard */.pr, {
                variant: "profile-config",
                title: renderTitle(),
                isHideTitle: step === ChangePhoneStep.Success,
                "data-cy": "change-index-form",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "securities-box-changePin",
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: getIsStepVisible(ChangePhoneStep.Verify),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePhone_Verify, {
                                onNext: function() {
                                    return setStep(ChangePhoneStep.Change);
                                },
                                cancelLink: "javascript:void(0)",
                                onClickCancel: backToEditForm
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: getIsStepVisible(ChangePhoneStep.Change),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePhone_NewPhone, {
                                phone: profile.phone,
                                onNext: function() {
                                    return setStep(ChangePhoneStep.SelectOtp);
                                },
                                cancelLink: "javascript:void(0)",
                                onClickCancel: backToEditForm
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: getIsStepVisible(ChangePhoneStep.SelectOtp),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePhone_SelectOtpMethod, {
                                onNext: function() {
                                    return setStep(ChangePhoneStep.Otp);
                                },
                                onError: handleVerifyPhoneError
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: getIsStepVisible(ChangePhoneStep.Otp),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OTP, {
                                onNext: function() {
                                    return setStep(ChangePhoneStep.Success);
                                },
                                onResend: function() {
                                    return setStep(ChangePhoneStep.SelectOtp);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: getIsStepVisible(ChangePhoneStep.Success),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessCard/* default */.Z, {
                                type: "phone",
                                backLink: backLink
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function ChangePhoneWithProgressGuard(props) {
    var _enableGuard = props.enableGuard, enableGuard = _enableGuard === void 0 ? false : _enableGuard;
    if (!enableGuard) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePhone, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressGuard/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePhone, (0,_object_spread/* default */.Z)({}, props))
        })
    });
}
/* harmony default export */ var edit_profile_ChangePhone = (ChangePhoneWithProgressGuard);


/***/ }),

/***/ 28145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ edit_profile_ModalOtpLimit; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/index.tsx
var BaseModal = __webpack_require__(16981);
;// CONCATENATED MODULE: ./src/features/edit-profile/ModalOtpLimit/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body {\n    padding: 32px 40px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 160px;\n  height: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.ant-btn.ant-btn-primary {\n    height: auto;\n    width: 100%;\n    padding: 12.5px;\n    border: none;\n\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 19px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var BaseOtpLimitModal = (0,styled_components_browser_esm["default"])(BaseModal/* default */.Z).withConfig({
    componentId: "sc-d048e9c2-0"
})(_templateObject());
var ModalIllustration = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-d048e9c2-1"
})(_templateObject1());
var BackButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-d048e9c2-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/features/edit-profile/ModalOtpLimit/index.tsx







var Text = ui/* Common.Text */.Gn.Text;
var ModalOtpLimit = function(_param) /*#__PURE__*/ {
    var _title = _param.title, title = _title === void 0 ? "Coba Lagi Setelah 1 Jam" : _title, _description = _param.description, description = _description === void 0 ? "Kamu telah mencapai limit pengiriman kode OTP sebanyak 5 kali." : _description, _buttonText = _param.buttonText, buttonText = _buttonText === void 0 ? "Oke" : _buttonText, _onBackClick = _param.onBackClick, onBackClick = _onBackClick === void 0 ? function() {} : _onBackClick, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "buttonText",
        "onBackClick"
    ]);
    return (0,jsx_runtime.jsx)(BaseOtpLimitModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 450,
        onCancel: onBackClick,
        hideHeader: true
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
            justify: "center",
            gutter: [
                0,
                24
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        align: "middle",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalIllustration, {
                                src: "/images/phone-otp-timer.svg"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        align: "middle",
                        justify: "center",
                        gutter: [
                            0,
                            16
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    align: "center",
                                    weight: "700",
                                    size: "24px",
                                    height: "32px",
                                    color: "#333333",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                    align: "center",
                                    size: "16px",
                                    height: "22px",
                                    color: "#858585",
                                    children: description
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                        type: "primary",
                        onClick: onBackClick,
                        children: buttonText
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var edit_profile_ModalOtpLimit = (ModalOtpLimit);


/***/ }),

/***/ 81430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76825);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29658);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(686);
// eslint-disable-next-line no-use-before-define






var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Text */ .Gn.Text, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Flex */ .Gn.Flex, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Iconmoon */ .Gn.Iconmoon;
function Navigation(param) {
    var _iconClass = param.iconClass, iconClass = _iconClass === void 0 ? "" : _iconClass, activeNav = param.activeNav, items = param.items, title = param.title, _prefixUrl = param.prefixUrl, prefixUrl = _prefixUrl === void 0 ? "/profile/edit" : _prefixUrl, _onNavItemClick = param.onNavItemClick, onNavItemClick = _onNavItemClick === void 0 ? function() {} : _onNavItemClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .NavigationHeader */ .B5, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            condition: iconClass,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Iconmoon, {
                                className: iconClass,
                                size: "27px",
                                style: {
                                    marginRight: 12
                                },
                                color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.highempahis */ .$_.highempahis
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                            family: "bold",
                            align: "center",
                            size: "16px",
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .CustomConfigNavigation */ .Tc, {
                children: items.map(function(nav) {
                    var isActive = nav.url.slice(1) === activeNav;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "".concat(prefixUrl).concat(nav.url),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .CustomNavigationItem */ .kr, {
                            onClick: function() {
                                return onNavItemClick(nav);
                            },
                            className: "menu",
                            isActive: isActive,
                            "data-cy": "setting-index-navigation-item",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                                    align: "left",
                                    children: nav.label
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                                    width: "18px",
                                    height: "18px",
                                    align: "center",
                                    justify: "center",
                                    children: [
                                        " ",
                                        nav.iconSVG ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(nav.iconSVG, {
                                            isActive: isActive
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Iconmoon, {
                                            className: "".concat(nav.icon),
                                            size: "14px",
                                            style: {
                                                color: isActive ? _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.primary */ .$_.primary : _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.highempahis */ .$_.highempahis
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, nav.value)
                    }, nav.value);
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Navigation);


/***/ }),

/***/ 61040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ edit_profile_ProgressGuard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/features/edit-profile/ProgressGuard/Card.tsx




var Card = ui/* Common.Card */.Gn.Card, Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var DefaultCard = /*#__PURE__*/ (0,react.memo)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
            width: "100%",
            justify: "center",
            align: "center",
            height: "300px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/settings.svg",
                alt: "profile-setting"
            })
        })
    });
});
var InProgressCard = /*#__PURE__*/ (0,react.memo)(function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
        "data-cy": "settings-in-progress-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
            width: "100%",
            justify: "center",
            align: "center",
            height: "320px",
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                    style: {
                        minHeight: "136px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/settings-in-progress.svg",
                        alt: "profile-setting"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    width: "100%",
                    justify: "center",
                    align: "center",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            size: "16px",
                            weight: "bold",
                            style: {
                                marginTop: 20
                            },
                            children: "Pembaruan Data Dalam Proses"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            size: "14px",
                            style: {
                                marginTop: 8
                            },
                            children: "Kamu baru bisa mengubah data lain setelah proses pembaruan selesai."
                        })
                    ]
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./src/features/edit-profile/constants.ts + 1 modules
var constants = __webpack_require__(8112);
;// CONCATENATED MODULE: ./src/features/edit-profile/ProgressGuard/index.tsx





function ProgressGuard(param) {
    var children = param.children;
    var ref;
    var ref1 = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "tradingProfilePersonal"
        ],
        queryFn: trade/* default.getTradingProfilePersonal */.Z.getTradingProfilePersonal
    }), isLoading = ref1.isLoading, errorPersonal = ref1.error, queryDataPersonal = ref1.data;
    if (isLoading || errorPersonal || (queryDataPersonal === null || queryDataPersonal === void 0 ? void 0 : queryDataPersonal.status) !== 200) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCard, {});
    }
    var _data = queryDataPersonal.data, resultPersonal = _data.data;
    var showInProgress = (resultPersonal === null || resultPersonal === void 0 ? void 0 : (ref = resultPersonal.status) === null || ref === void 0 ? void 0 : ref.enum) === constants/* PROGRESS_STATUS_ENUM.in_progress */.CJ.in_progress;
    if (showInProgress) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InProgressCard, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
}
/* harmony default export */ var edit_profile_ProgressGuard = (ProgressGuard);


/***/ }),

/***/ 61960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ConfirmOTP; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(31151);
// EXTERNAL MODULE: ./src/utils/textFormatter.ts
var textFormatter = __webpack_require__(23485);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/edit-profile/components/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  overflow: hidden;\n  border: 1px solid rgb(218, 218, 218);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  width: 24px;\n  height: 36px;\n  font-size: 16px;\n  text-align: center;\n  padding: 0;\n  outline: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Input = ui/* Common.Input */.Gn.Input;
var InputContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2bfa0b60-0"
})(_templateObject());
var InputNumber = styled_components_browser_esm["default"].input.withConfig({
    componentId: "sc-2bfa0b60-1"
})(_templateObject1());

// EXTERNAL MODULE: ./src/features/edit-profile/styled.ts
var styled = __webpack_require__(686);
;// CONCATENATED MODULE: ./src/features/edit-profile/components/ConfirmOTP.tsx











var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var MAX_LENGTH = 4;
var KEY_CODE_BACKSPACE = 8;
var KEY_CODE_DELETE = 46;
var DEFAULT_CD_DURATION = 60;
var CONTENT = {
    email: "melalui email",
    phone: "ke nomor "
};
function ConfirmOTP(param) {
    var isLoading = param.isLoading, onSubmit = param.onSubmit, onResend = param.onResend, phoneNumber = param.phoneNumber, _type = param.type, type = _type === void 0 ? "email" : _type;
    var inputRef = (0,react.useRef)((0,_to_consumable_array/* default */.Z)(Array(MAX_LENGTH)).map(function() {
        return /*#__PURE__*/ (0,react.createRef)();
    }));
    var ref = (0,react.useState)((0,_to_consumable_array/* default */.Z)(Array(MAX_LENGTH))), inputValue = ref[0], setInputValue = ref[1];
    var onChangeInput = function(e) {
        return function(index) {
            var value = e.target.value;
            var newInputValue = (0,_to_consumable_array/* default */.Z)(inputValue);
            if (e.keyCode !== KEY_CODE_BACKSPACE && e.keyCode !== KEY_CODE_DELETE) {
                // eslint-disable-next-line prefer-destructuring
                newInputValue[index] = value[0];
                setInputValue(newInputValue);
                setTimeout(function() {
                    if (index < 3 && inputRef.current[index].current.value !== "") {
                        inputRef.current[index + 1].current.focus();
                    }
                }, 50);
            }
            if (e.keyCode === KEY_CODE_BACKSPACE) {
                newInputValue[index] = "";
                setInputValue(newInputValue);
                setTimeout(function() {
                    if (index > 0 && index <= MAX_LENGTH - 1) {
                        inputRef.current[index - 1].current.focus();
                    }
                }, 50);
            }
        };
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var otp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        otp = inputValue.join("");
                        onSubmit(otp);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return onResend();
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    var suffix = type === "email" ? CONTENT.email : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            CONTENT.phone,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                children: [
                    "+",
                    (0,textFormatter/* formatCensorPhoneNumber */.E)(phoneNumber)
                ]
            })
        ]
    });
    var ref1 = (0,useCountdown/* default */.Z)({
        onResend: function() {
            handleResend();
        },
        time: DEFAULT_CD_DURATION
    }), seconds = ref1.seconds, minutes = ref1.minutes, onEnd = ref1.onEnd, isFinished = ref1.isFinished;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        size: "16px",
                        family: "bold",
                        height: "1.5",
                        children: "Masukkan Kode Verifikasi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                        mb: "15px",
                        height: "1.5",
                        color: ui/* color.highgray */.$_.highgray,
                        children: [
                            "Kode verifikasi telah dikirim ",
                            suffix
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                align: "center",
                style: {
                    gap: 16
                },
                mb: "15px",
                children: [
                    (0,_to_consumable_array/* default */.Z)(Array(MAX_LENGTH)).map(function(_e, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber, {
                                ref: inputRef.current[i],
                                value: inputValue[i],
                                onChange: function(e) {
                                    return onChangeInput(e)(i);
                                },
                                onKeyDown: function(e) {
                                    return onChangeInput(e)(i);
                                },
                                id: "input-email-otp-verify-".concat(i + 1),
                                "data-cy": "confirm-otp-input-box"
                            })
                        }, "input-token".concat(i + 1));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !isFinished,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                            color: ui/* color.highgray */.$_.highgray,
                            "data-cy": "confirm-otp-count-down",
                            children: [
                                "Kirim Ulang",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                    condition: !isFinished,
                                    children: [
                                        "(",
                                        minutes,
                                        ":",
                                        seconds,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isFinished,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            color: ui/* color.primary */.$_.primary,
                            family: "bold",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: onEnd,
                            "data-cy": "confirm-otp-kirim-ulang-button",
                            children: "Kirim Ulang"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* PasswordSubmitButton */.G_, {
                    htmlType: "submit",
                    type: "primary",
                    loading: isLoading,
                    onClick: handleSubmit,
                    "data-cy": "confirm-otp-submit-button",
                    children: "Submit"
                })
            })
        ]
    });
}
/* harmony default export */ var components_ConfirmOTP = (ConfirmOTP);


/***/ }),

/***/ 44278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2497);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(333);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14229);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8112);
/* eslint-disable no-undef */ 








var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function SuccessCard(param) {
    var type = param.type, backLink = param.backLink;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        // @ts-ignore
        var username = utils_auth__WEBPACK_IMPORTED_MODULE_7__/* ["default"].getUserAccess */ .Z.getUserAccess().username;
        // @ts-ignore
        dispatch(lib_entities_profile__WEBPACK_IMPORTED_MODULE_6__/* .effects.getUserProfile */ .Sz.getUserProfile(username));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
        direction: "column",
        width: "100%",
        justify: "center",
        align: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                src: "/icon/previewOrder-success.svg",
                alt: "success"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                family: "bold",
                size: "22px",
                mt: "20px",
                "data-cy": "success-card-text",
                children: "Berhasil"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                children: _constants__WEBPACK_IMPORTED_MODULE_8__/* .SUCCESS_CONTENT */ .oE[type.toUpperCase()]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: backLink,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                    type: "primary",
                    mt: "20px",
                    mb: "50px",
                    width: "80px",
                    "data-cy": "succes-card-ok-button",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        family: "bold",
                        my: "px",
                        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light,
                        children: "Oke"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SuccessCard);


/***/ }),

/***/ 22105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _ChangePassword_PasswordField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41283);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(686);







var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function VerifyPassword(param) {
    var isLoading = param.isLoading, onSubmit = param.onSubmit, cancelLink = param.cancelLink, _onClickCancel = param.onClickCancel, onClickCancel = _onClickCancel === void 0 ? function() {} : _onClickCancel;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), password = ref[0], setPassword = ref[1];
    var handleSubmit = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        var pw = password;
        setPassword("");
        onSubmit(pw);
    };
    var handleCancel = function() {
        setPassword("");
        onClickCancel();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
            p: "0 20px 20px 20px",
            width: "100%",
            direction: "column",
            margin: "auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                    direction: "column",
                    width: "300px",
                    mb: "10px",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                            mb: "20px",
                            children: "Masukkan Password Stockbit Kamu"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ChangePassword_PasswordField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            value: password,
                            onChange: setPassword,
                            isError: false
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                            family: "bold",
                            color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary,
                            mt: "20px",
                            onClick: function() {
                                return router.push("/forgot-password");
                            },
                            style: {
                                cursor: "pointer"
                            },
                            "data-cy": "verify-password-forget-password-link",
                            children: "Lupa password?"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                    mt: "10px",
                    ml: "-15px",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: cancelLink,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .PasswordCancelButton */ .m$, {
                                disabled: false,
                                onClick: handleCancel,
                                "data-cy": "verify-password-cancel-button",
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .PasswordSubmitButton */ .G_, {
                            htmlType: "submit",
                            disabled: !password,
                            type: "primary",
                            loading: isLoading,
                            onClick: handleSubmit,
                            "data-cy": "verify-password-submit-button",
                            children: "Submit"
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (VerifyPassword);


/***/ }),

/***/ 72228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ VerifyPhoneErrorType; }
/* harmony export */ });
var VerifyPhoneErrorType;
(function(VerifyPhoneErrorType) {
    VerifyPhoneErrorType["OtpLimit"] = "OTP_LIMIT";
})(VerifyPhoneErrorType || (VerifyPhoneErrorType = {}));


/***/ }),

/***/ 10504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "fv": function() { return /* binding */ InputContainer; },
/* harmony export */   "y": function() { return /* binding */ ErrorText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  label {\n    font-family: 'ProximaNovaLt';\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  width: 100% !important;\n  font-family: 'ProximaNovaLt' !important;\n  font-weight: 300;\n\n  input {\n    &::placeholder {\n      font-family: 'ProximaNovaLt';\n      font-weight: 300;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaLt';\n  font-weight: 300;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var InputContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.InputContainer */ .Gn.InputContainer).withConfig({
    componentId: "sc-a161563b-0"
})(_templateObject());
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Input */ .Gn.Input).attrs({
    p: "0",
    type: "password"
}).withConfig({
    componentId: "sc-a161563b-1"
})(_templateObject1());
var ErrorText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text).attrs({
    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.venetianRed */ .$_.venetianRed
}).withConfig({
    componentId: "sc-a161563b-2"
})(_templateObject2());



/***/ }),

/***/ 30503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomInput_password; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/CustomInput/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  border: none;\n  cursor: pointer;\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100% !important;\n  &.error {\n    border-color: ",
        ";\n    &:not(.ant-input-affix-wrapper-disabled):hover {\n      border-color: ",
        ";\n    }\n  }\n  &:not(.ant-input-affix-wrapper-disabled):hover {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var BaseInput = ui/* Common.Input */.Gn.Input;
var EyeButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-ccde1e14-0"
})(_templateObject());
var Input = (0,styled_components_browser_esm["default"])(BaseInput).withConfig({
    componentId: "sc-ccde1e14-1"
})(_templateObject1(), ui/* color.sunsetOrange */.$_.sunsetOrange, ui/* color.sunsetOrange */.$_.sunsetOrange, ui/* color.primary */.$_.primary);

;// CONCATENATED MODULE: ./src/global/CustomInput/password.tsx






var PasswordInput = function(_param) {
    var _error = _param.error, error = _error === void 0 ? false : _error, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "error"
    ]);
    var ref = (0,react.useState)("password"), type = ref[0], setType = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
        type: type,
        className: error ? "error" : "",
        suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(EyeButton, {
            type: "button",
            onClick: function() {
                return setType(type === "text" ? "password" : "text");
            },
            "data-cy": "custom-input-password-eye-toggle",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: type === "password" ? "/icon/eye.svg" : "/icon/eye-off.svg",
                alt: ""
            })
        })
    }, rest));
};
/* harmony default export */ var CustomInput_password = (PasswordInput);


/***/ }),

/***/ 37662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChatSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.5 18.625C2.33424 18.625 2.17527 18.5592 2.05806 18.4419C1.94085 18.3247 1.875 18.1658 1.875 18V4.66667C1.87544 4.05901 2.11702 3.47638 2.5467 3.0467C2.97637 2.61703 3.55901 2.37544 4.16667 2.375H15.8333C16.441 2.37544 17.0236 2.61703 17.4533 3.0467C17.883 3.47638 18.1246 4.05901 18.125 4.66667V13C18.1246 13.6077 17.883 14.1903 17.4533 14.62C17.0236 15.0496 16.441 15.2912 15.8333 15.2917H6.0925L2.94167 18.4417C2.88379 18.4999 2.81497 18.546 2.73917 18.5775C2.66336 18.609 2.58208 18.6251 2.5 18.625ZM4.16667 3.625C3.89053 3.62544 3.62584 3.73533 3.43058 3.93058C3.23533 4.12584 3.12544 4.39053 3.125 4.66667V16.4908L5.39167 14.225C5.44957 14.1668 5.5184 14.1207 5.5942 14.0892C5.66999 14.0578 5.75126 14.0416 5.83333 14.0417H15.8333C16.1095 14.0412 16.3742 13.9313 16.5694 13.7361C16.7647 13.5408 16.8746 13.2761 16.875 13V4.66667C16.8746 4.39053 16.7647 4.12584 16.5694 3.93058C16.3742 3.73533 16.1095 3.62544 15.8333 3.625H4.16667Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChatSvg);


/***/ }),

/***/ 68749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var WhatsAppSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.54912 14.328C2.6173 12.7572 2.29097 10.9002 2.6314 9.10583C2.97184 7.31142 3.95563 5.70301 5.39803 4.58261C6.84044 3.46222 8.64224 2.90692 10.4651 3.02099C12.2879 3.13506 14.0065 3.91065 15.2979 5.20212C16.5894 6.49359 17.365 8.2121 17.4791 10.035C17.5932 11.8578 17.0379 13.6596 15.9175 15.102C14.7971 16.5444 13.1887 17.5282 11.3943 17.8687C9.59988 18.2091 7.74291 17.8828 6.17207 16.951L6.17209 16.9509L3.58174 17.691C3.47456 17.7216 3.36115 17.723 3.25326 17.6951C3.14536 17.6671 3.0469 17.6108 2.96809 17.532C2.88927 17.4532 2.83297 17.3547 2.80501 17.2468C2.77705 17.1389 2.77846 17.0255 2.80908 16.9184L3.54918 14.328L3.54912 14.328Z",
                stroke: "currentColor",
                strokeWidth: "0.9375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.8839 14.875C11.0616 14.8762 10.2472 14.7151 9.48733 14.4009C8.72744 14.0868 8.03701 13.6258 7.45558 13.0444C6.87416 12.463 6.41318 11.7726 6.09906 11.0127C5.78493 10.2528 5.62384 9.43837 5.62501 8.61612C5.62687 8.03735 5.85821 7.48294 6.2683 7.07452C6.67839 6.6661 7.23373 6.43701 7.8125 6.4375C7.90743 6.4375 8.00068 6.4626 8.08278 6.51025C8.16489 6.55789 8.23294 6.6264 8.28004 6.70883L9.1934 8.30721C9.24849 8.4036 9.2769 8.51293 9.27572 8.62394C9.27454 8.73496 9.2438 8.84366 9.18668 8.93886L8.45316 10.1614C8.83054 10.9989 9.50113 11.6695 10.3386 12.0468L11.5611 11.3133C11.6563 11.2562 11.765 11.2255 11.8761 11.2243C11.9871 11.2231 12.0964 11.2515 12.1928 11.3066L13.7912 12.22C13.8736 12.2671 13.9421 12.3351 13.9898 12.4172C14.0374 12.4993 14.0625 12.5926 14.0625 12.6875C14.0608 13.2656 13.8311 13.8197 13.4231 14.2293C13.0151 14.639 12.462 14.871 11.8839 14.875Z",
                stroke: "currentColor",
                strokeWidth: "0.9375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WhatsAppSvg);


/***/ }),

/***/ 50226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_OtpMethodList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(32808);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/SelectCardMethod/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  cursor: pointer;\n\n  border: ",
        ";\n  border-radius: 4px;\n  padding: 16px;\n\n  transition: 0.15s ease-out border;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-checkbox-inner,\n  & .ant-checkbox-checked::after {\n    border-radius: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var ButtonContainer = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-feb18f86-0"
})(_templateObject(), function(param) {
    var isActive = param.isActive;
    return isActive ? "1px solid #00ab6b" : "1px solid #ededed";
});
var BoxRow = (0,styled_components_browser_esm["default"])(row/* default */.Z).withConfig({
    componentId: "sc-feb18f86-1"
})(_templateObject1());
var IconCol = (0,styled_components_browser_esm["default"])(col/* default */.Z).withConfig({
    componentId: "sc-feb18f86-2"
})(_templateObject2());
var MethodCheckbox = (0,styled_components_browser_esm["default"])(es_checkbox/* default */.Z).withConfig({
    componentId: "sc-feb18f86-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/global/SelectCardMethod/index.tsx






var Text = ui/* Common.Text */.Gn.Text;
var SelectCardMethod = function(_param) /*#__PURE__*/ {
    var title = _param.title, description = _param.description, icon = _param.icon, _onClick = _param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "icon",
        "onClick"
    ]);
    return (0,jsx_runtime.jsx)(ButtonContainer, {
        type: "button",
        onClick: function() {
            return onClick(props.value);
        },
        isActive: props.checked,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxRow, {
            align: "middle",
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        align: "middle",
                        gutter: [
                            16,
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCol, {
                                children: icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "14px",
                                        height: "16px",
                                        color: "#333333",
                                        weight: props.checked ? "700" : "400",
                                        mb: "2px",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "12px",
                                        height: "16px",
                                        color: "#858585",
                                        children: description
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodCheckbox, (0,_object_spread/* default */.Z)({}, props))
                })
            ]
        })
    });
};
/* harmony default export */ var global_SelectCardMethod = (SelectCardMethod);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/typings/auth.ts
var auth = __webpack_require__(97718);
;// CONCATENATED MODULE: ./src/global/OtpMethodList/index.tsx






var OtpMethodList = function(param) {
    var _defaultMethod = param.defaultMethod, defaultMethod = _defaultMethod === void 0 ? auth/* OtpChannel.WhatsApp */.z.WhatsApp : _defaultMethod, data = param.data, _onSelect = param.onSelect, onSelect = _onSelect === void 0 ? function() {} : _onSelect;
    var ref = (0,react.useState)(defaultMethod), selectedMethod = ref[0], setSelectedMethod = ref[1];
    var handleMethodClick = function(value) {
        setSelectedMethod(value);
        onSelect(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
        gutter: [
            0,
            12
        ],
        children: data.map(function(props) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_SelectCardMethod, (0,_object_spread/* default */.Z)({
                    onClick: handleMethodClick,
                    checked: selectedMethod === props.value
                }, props))
            }, props.value);
        })
    });
};
/* harmony default export */ var global_OtpMethodList = (OtpMethodList);


/***/ }),

/***/ 62780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51767);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85945);


var queryClient = new _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .QueryClient */ .S();
var QueryProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryClientProvider */ .aH, {
        client: queryClient,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QueryProvider);


/***/ }),

/***/ 31151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function useCountdown(param) {
    var onResend = param.onResend, _time = param.time, time = _time === void 0 ? 60 : _time;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(time), seconds = ref[0], setSeconds = ref[1];
    var startTimer = function() {
        setSeconds(time);
    };
    var formatNumber = function(number) {
        return number.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
    };
    var onEnd = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return onResend();
                    case 2:
                        startTimer();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onEnd() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var interval = setInterval(function() {
            if (seconds > 0) {
                setSeconds(seconds - 1);
                return;
            }
            clearInterval(interval);
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        seconds
    ]);
    var formatterSeconds = formatNumber(seconds % 60);
    var formattedMinutes = formatNumber(Math.floor(seconds / 60));
    var isFinished = seconds === 0;
    return {
        minutes: formattedMinutes,
        seconds: formatterSeconds,
        isFinished: isFinished,
        onEnd: onEnd
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useCountdown);


/***/ }),

/***/ 15077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Form value with state wrapper
 * @param {Object=} props
 * @param {*=} props.initialState
 * @returns {[*, function]}
 */ function useForm(param) {
    var _initialState = param.initialState, initialState = _initialState === void 0 ? "" : _initialState;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState), value = ref[0], setValue = ref[1];
    var handleChange = function(e) {
        setValue(e.target.value);
    };
    return [
        value,
        handleChange
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useForm);


/***/ }),

/***/ 72360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ formatRemoveErrorTypeMobile; }
/* harmony export */ });
// error_type=1 is used by mobile platform only to handle old version of their app
var formatRemoveErrorTypeMobile = function(message) {
    return message.replace("|error_type=1", "");
};


/***/ }),

/***/ 23485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ formatCensorPhoneNumber; },
/* harmony export */   "u": function() { return /* binding */ formatPhoneNumber; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);

var formatPhoneNumber = function(phone) {
    try {
        if (!phone) return "";
        var splitLength = Math.ceil((phone.length - 5) / 4);
        var splitArray = [
            phone.substring(0, 2),
            phone.substring(2, 5), 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Array(splitLength).fill(4).map(function(_, idx) {
            return phone.substring(5 + 4 * idx, 5 + 4 * (idx + 1));
        })));
        return "".concat(splitArray.join("-"));
    } catch (e) {
        return phone;
    }
};
var formatCensorPhoneNumber = function(phone) {
    if (!phone) return "";
    return "".concat(phone.substring(0, 2), " ").concat(phone.substring(2, 4), "******").concat(phone.substring(phone.length - 3, phone.length), "\n  ");
};


/***/ })

}]);